import React, { Component } from 'react';
import { observer } from 'mobx-react';
import UdeDebugMenuItem from 'app/views/boards/panels/ude/debug/UdeDebugMenuItem';
import MovePanelButton from './MovePanelButton';

@observer
class PanelOptions extends Component {
  handleMovePanel = (toSectionId) => {
    const { panel, onSectionChange } = this.props;
    onSectionChange(panel, toSectionId);
  };

  render() {
    const { panel } = this.props;

    const hasSections = (panel.collection.get() || []).some((p) => p.get('type') === 'section');
    const isUde = panel.get('type') === 'ude';

    if (!hasSections && !isUde) {
      return null;
    }

    return (
      <>
        {hasSections && (
          <MovePanelButton panel={panel} text="Move Panel to Section" onMovePanel={this.handleMovePanel} />
        )}
        {isUde && <UdeDebugMenuItem panel={panel} />}
      </>
    );
  }
}

export default PanelOptions;
